import { call, put, takeLatest, all, fork } from 'redux-saga/effects';
import {
  fetchNotificationBannersSuccess,
  fetchNotificationBannersFailure,
  setNotificationBannerLoading,
  fetchSiteNotificationsSuccess,
  fetchSiteNotificationsFailure,
  fetchSiteNotificationsLoading,
  saveSiteNotificationSuccess,
  saveSiteNotificationFailure,
  fetchSiteNotificationsRequest,
} from '../actions/NotificationBannerActions';
import { fetchNotificationBanners, fetchSiteNotifications, saveSiteNotification } from '../services/notificationBanner/NotificationBanner.service';
import { FETCH_NOTIFICATION_BANNERS_REQUEST, FETCH_SITE_NOTIFICATIONS_REQUEST, SAVE_SITE_NOTIFICATION_REQUEST } from '../actions/actionTypes';

export function* fetchNotificationBannersSaga(action: any) {
  try {
    yield put(setNotificationBannerLoading(true));
    const response = yield call(fetchNotificationBanners);
    if (response) {
      yield put(fetchNotificationBannersSuccess(response?.Data || response));
    }
  } catch (error) {
    yield put(fetchNotificationBannersFailure(error));
  } finally {
    yield put(setNotificationBannerLoading(false));
  }
}

// Add new saga for site notifications
function* fetchSiteNotificationsSaga(): Generator<any, void, any> {
  try {
    yield put(fetchSiteNotificationsLoading(true));
    const response = yield call(fetchSiteNotifications);
    if (response && response.length > 0) {
      yield put(fetchSiteNotificationsSuccess(response));
    } else {
      yield put(fetchSiteNotificationsFailure(true));
    }
  } catch (error: any) {
    yield put(fetchSiteNotificationsFailure(true));
  } finally {
    yield put(fetchSiteNotificationsLoading(false));
  }
}

// Add new saga for saving site notifications
function* saveSiteNotificationSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(saveSiteNotification, action.payload);
    if (response && response.StatusCode === 200) {
      yield put(saveSiteNotificationSuccess(response));
      // After successful save, refresh the site notifications list
      yield put(fetchSiteNotificationsRequest());
    }
  } catch (error: any) {
    yield put(saveSiteNotificationFailure(error));
  }
}

// Add watcher for notification banners
function* watchFetchNotificationBanners() {
  yield takeLatest(FETCH_NOTIFICATION_BANNERS_REQUEST, fetchNotificationBannersSaga);
}

// Add new watcher saga
function* watchFetchSiteNotifications() {
  yield takeLatest(FETCH_SITE_NOTIFICATIONS_REQUEST, fetchSiteNotificationsSaga);
}

// Add new watcher saga for saving site notifications
function* watchSaveSiteNotification() {
  yield takeLatest(SAVE_SITE_NOTIFICATION_REQUEST, saveSiteNotificationSaga);
}

// Update root saga to include new watcher
export function* notificationBannerSaga() {
  yield all([
    fork(watchFetchNotificationBanners),
    fork(watchFetchSiteNotifications), // Add this line
    fork(watchSaveSiteNotification), // Add this line
  ]);
}

export default [notificationBannerSaga];